const selectors: Record<
  | "header"
  | "navigationButton"
  | "navigationMenu"
  | "navigationMenuContent"
  | "navigationMenuChildren"
  | "headerMobile"
  | "headerMobileButton"
  | "headerMobileMenuButton"
  | "headerMobileMenuPanel"
  | "headerMobileMenuPanelClose",
  string
> = {
  header: "[data-header]",
  navigationButton: "[data-header-navigation-button]",
  navigationMenu: "[data-header-navigation-menu]",
  navigationMenuContent: "[data-header-navigation-menu-content]",
  navigationMenuChildren: "[data-header-navigation-menu-children]",
  headerMobile: "[data-header-mobile]",
  headerMobileButton: "[data-header-mobile-menu]",
  headerMobileMenuButton: "[data-header-mobile-menu-button]",
  headerMobileMenuPanel: "[data-header-mobile-menu-panel]",
  headerMobileMenuPanelClose: "[data-header-mobile-menu-panel-close]",
};

const elements: Record<
  | "header"
  | "navigationButton"
  | "navigationMenu"
  | "navigationMenuContent"
  | "navigationMenuChildren"
  | "headerMobile"
  | "headerMobileButton"
  | "headerMobileMenuButton"
  | "headerMobileMenuPanel"
  | "headerMobileMenuPanelClose",
  null | HTMLElement | NodeListOf<HTMLElement> | Element[]
> = {
  header: null,
  navigationButton: null,
  navigationMenu: null,
  navigationMenuContent: null,
  navigationMenuChildren: null,
  headerMobile: null,
  headerMobileButton: null,
  headerMobileMenuButton: null,
  headerMobileMenuPanel: null,
  headerMobileMenuPanelClose: null,
};

const states: Record<"active" | "hidden" | "open" | "close", string> = {
  active: "active",
  hidden: "hidden",
  open: "open",
  close: "close",
};

function desktopMenuChangeVisible(
  button: HTMLElement | undefined,
  buttons: Element[] | undefined = []
) {
  const menuName = button?.innerText as string;
  const menuPosition = button?.getAttribute("data-header-navigation-button-position");

  if (button) {
    // @ts-ignore
    elements.header?.setAttribute("data-header-position", menuPosition);
    setTimeout(() => {
      // @ts-ignore
      elements.header?.setAttribute("data-header", states.active);
    }, 100);
  }

  buttons.forEach((b) => b.setAttribute("data-header-navigation-button", ""));
  button?.setAttribute("data-header-navigation-button", states.active);

  // @ts-ignore
  elements.navigationMenuChildren.forEach((menu) =>
    menu.classList[
      menu.getAttribute("data-header-navigation-menu-children") === menuName?.trim()
        ? "remove"
        : "add"
    ](states.hidden)
  );
}

function initDesktop() {
  elements.navigationButton = Array.from(document.querySelectorAll(selectors.navigationButton));
  elements.navigationMenu = document.querySelector(selectors.navigationMenu) as HTMLElement;
  elements.navigationMenuContent = document.querySelector(
    selectors.navigationMenuContent
  ) as HTMLElement;
  elements.navigationMenuChildren = Array.from(
    document.querySelectorAll(selectors.navigationMenuChildren)
  );

  elements.navigationButton.forEach((button, _, buttons) => {
    button.addEventListener("mouseover", () =>
      desktopMenuChangeVisible(button as HTMLElement, buttons)
    );
  });

  document.addEventListener("click", (e) => {
    // @ts-ignore
    if (!elements.navigationMenuContent.contains(e.target)) {
      desktopMenuChangeVisible(undefined, elements.navigationButton as Element[]);
      // @ts-ignore
      elements.header?.setAttribute("data-header", "");
      setTimeout(() => {
        // @ts-ignore
        elements.header?.setAttribute("data-header-position", "");
      }, 300);
    }
  });
}

function toggleMobileMenu(e: { currentTarget: Element }) {
  const state = e.currentTarget.getAttribute("data-header-mobile-menu");

  const header = elements.headerMobile as Element;
  header.setAttribute("data-header-mobile", state === states.open ? states.active : "");
}

function initMobile() {
  elements.headerMobile = document.querySelector(selectors.headerMobile) as HTMLElement;

  if (!elements.headerMobile) return;

  elements.headerMobileButton = Array.from(
    document.querySelectorAll(selectors.headerMobileButton)
  ) as Element[];
  elements.headerMobileMenuButton = Array.from(
    document.querySelectorAll(selectors.headerMobileMenuButton)
  ) as Element[];
  elements.headerMobileMenuPanel = Array.from(
    document.querySelectorAll(selectors.headerMobileMenuPanel)
  ) as Element[];
  elements.headerMobileMenuPanelClose = Array.from(
    document.querySelectorAll(selectors.headerMobileMenuPanelClose)
  ) as Element[];

  elements.headerMobileButton.forEach((button: Element) =>
    // @ts-ignore
    button.addEventListener("click", toggleMobileMenu)
  );

  elements.headerMobileMenuButton.forEach((button) =>
    button.addEventListener("click", (e) => {
      // @ts-ignore
      const menuName = e.currentTarget.getAttribute("data-header-mobile-menu-button");

      // @ts-ignore
      elements.headerMobileMenuPanel.forEach((panel: Element) => {
        const panelName = panel.getAttribute("data-header-mobile-menu-panel");

        if (panelName === menuName) {
          panel.classList.remove(states.hidden);
        }
      });
    })
  );

  elements.headerMobileMenuPanelClose.forEach((button) =>
    button.addEventListener("click", (e) => {
      // @ts-ignore
      e.target.closest("[data-header-mobile-menu-panel]").classList.add(states.hidden);
    })
  );
}

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    elements.header = document.querySelector(selectors.header) as HTMLElement;

    if (!elements.header) return;

    document.addEventListener("scroll", () => {
      // @ts-ignore
      elements.header.setAttribute(
        "data-header-scrolled",
        window.scrollY >= 20 ? states.active : states.hidden
      );
    });

    initDesktop();
    initMobile();
  },
  {
    once: true,
  }
);
